import { useRef, type MutableRefObject } from 'react';

/**
 * Ref that always holds the latest `value`, updated synchronously on every
 * render (no effect). Lets callbacks/timers/SDK handlers read fresh state
 * without re-subscribing or taking `value` as an effect dependency.
 */
export const useLatestRef = <T>(value: T): MutableRefObject<T> => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};
